"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _notistack = require("notistack");
var _SnackbarService = _interopRequireDefault(require("./SnackbarService.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnackbarRefProvider = props => {
  props.onSnackbarRef((0, _notistack.useSnackbar)());
  return null;
};
const SnackbarServiceHost = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(SnackbarRefProvider, {
  onSnackbarRef: snackbarRef => _SnackbarService.default.notistack = snackbarRef
});
var _default = exports.default = SnackbarServiceHost;